import React from 'react';
import { PatternFormat, PatternFormatProps } from 'react-number-format';
import { TextField } from '@mui/material';

interface CepProps {
  value: string | undefined;
  onValueChange: (value: string) => void;
  variant?: 'outlined' | 'standard';
  label?: string;
  error?: boolean;
  helperText?: string | boolean;
}

const CepTextField = React.forwardRef<PatternFormatProps<never>, CepProps>(
  (props, ref) => {
    const {
      value,
      onValueChange,
      variant,
      label,
      error,
      helperText,
      ...other
    } = props;

    return (
      <PatternFormat
        {...other}
        label={label}
        placeholder="CEP"
        onValueChange={value => onValueChange(value.formattedValue)}
        customInput={TextField}
        helperText={helperText}
        error={error}
        variant={variant}
        value={value}
        style={{ width: '100%', marginBottom: 16 }}
        format="#####-###"
        getInputRef={ref}
        type="text"
      />
    );
  }
);

CepTextField.displayName = 'CepTextField';

export default CepTextField;
